import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PublicApiKeyService } from '../_services/public-api-key.service';
@Injectable()
export class PublicApiKeyInterceptor implements HttpInterceptor {
  constructor(
    private publicApiKeyService: PublicApiKeyService
  ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiKey = this.publicApiKeyService.getApiKey();
    const isPublicRoute = window.location.hash.includes('/public/');
    
    console.log('[PublicApiKeyInterceptor] Request URL:', request.url);
    console.log('[PublicApiKeyInterceptor] Has API key:', !!apiKey);
    console.log('[PublicApiKeyInterceptor] Is public route:', isPublicRoute);
    console.log('[PublicApiKeyInterceptor] Current hash:', window.location.hash);
    
    if (apiKey && isPublicRoute && !request.headers.has('Authorization')) {
      console.log('[PublicApiKeyInterceptor] Adding x-api-key header');
      request = request.clone({
        setHeaders: {
          'x-api-key': apiKey
        }
      });
    } else {
      console.log('[PublicApiKeyInterceptor] NOT adding x-api-key header');
    }
    
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('[PublicApiKeyInterceptor] Request error:', error);
        if ((error.status === 401 || error.status === 403) && isPublicRoute) {
          console.log('[PublicApiKeyInterceptor] Clearing API key and reloading');
          this.publicApiKeyService.clearApiKey();
          window.location.reload();
        }
        return throwError(() => error);
      })
    );
  }
}

